import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CmsConfig, provideDefaultConfig, UrlModule } from '@spartacus/core'
import { FormErrorsModule, SpinnerModule } from '@spartacus/storefront'
import { DispenserAgreementStatusGuard } from '../../../../../guards/dispenser-agreement-status.guard'
import { UserPermissionsGuard } from '../../../../../guards/user-permissions.guard'
import { MaterialModule } from '../../../../shared/material.module'
import { SharedModule } from '../../../../shared/shared.module'
import { UpdateDispenserAgreementComponent } from './update-dispenser-agreement.component'

@NgModule({
  declarations: [UpdateDispenserAgreementComponent],
  imports: [
    RouterModule,
    UrlModule,
    SharedModule,
    MaterialModule,
    SpinnerModule,
    ReactiveFormsModule,
    FormsModule,
    FormErrorsModule,
    CommonModule
  ],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        UpdateDispenserAgreementComponent: {
          component: UpdateDispenserAgreementComponent,
          guards: [UserPermissionsGuard, DispenserAgreementStatusGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class UpdateDispenserAgreementModule {}
